// Formato de teléfono mexicano a 10 dígitos. Función pura — shared/lib (§6.2 de la arquitectura).

/**
 * Las cuatro LADAs de DOS dígitos del plan del IFT: CDMX (55 y 56), Guadalajara y Monterrey. El
 * resto del país las tiene de tres, y por eso el agrupado no puede ser fijo — con 2-4-4 un número
 * de Querétaro sale «30 1211 1146».
 */
const TWO_DIGIT_AREA_CODES = new Set(['55', '56', '33', '81']);

/** `5512340001` → `55 1234 0001` · `3012111146` → `301 211 1146`. Vacío si no hay teléfono. */
export function formatPhone(phone: string | null | undefined): string {
    if (!phone) return '';
    const digits = toNationalDigits(phone);
    if (digits.length !== 10) return phone;
    return TWO_DIGIT_AREA_CODES.has(digits.slice(0, 2))
        ? `${digits.slice(0, 2)} ${digits.slice(2, 6)} ${digits.slice(6)}`
        : `${digits.slice(0, 3)} ${digits.slice(3, 6)} ${digits.slice(6)}`;
}

/** Deja solo dígitos y quita el 52 de país cuando el teléfono llega en E.164. */
function toNationalDigits(phone: string): string {
    const digits = phone.replace(/\D/g, '');
    return digits.length === 12 && digits.startsWith('52') ? digits.slice(2) : digits;
}
